import React, { useState, useEffect } from 'react';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { useDispatch, useSelector } from 'react-redux';

import { changeScreen } from '../../redux/actions/user-flow/user-flow-action';
import { addInstapoints } from '@Redux/actions/transaction/transaction-action';
import { USER_FLOW_PREV } from '../../redux/action-contants';
import './back-button.css';
import { joinClassNames } from '../../utils/library';
import { BACK_ARROW_ICON, BACK_ARROW_SVG_ICON, BACK_BUTTON_ONBOARDING_ICON } from '@Images';
import { getUserFlowReducer } from '@Redux/selectors';

type injectedProps = {
  className?: string;
  goBack?: any;
  isModal?: any;
  onCloseFn?: any;
  newBackButton?: boolean;
  newOnboardingScreen?: boolean;
};

type IProps = {
  comp?: React.ReactElement<any>;
} & injectedProps;

const BackButton: React.FC<IProps> = ({
  className,
  goBack,
  isModal,
  onCloseFn,
  newBackButton,
  newOnboardingScreen,
  comp
}) => {
  const [isFirstScreen, setIsFirstScreen] = useState(false);
  const { screens, currentScreen, timeline } = useSelector(getUserFlowReducer);
  const dispatch = useDispatch<ThunkDispatch<any, any, AnyAction>>();

  useEffect(() => {
    /* do not show back arrow image for first screen */
    if (currentScreen && screens && screens[0].name === currentScreen && !isModal) {
      setIsFirstScreen(true);
    }
  }, [currentScreen, screens, isModal]);

  const handleGoBack = () => {
    dispatch(addInstapoints(null));
    if (isModal && onCloseFn) {
      onCloseFn();
    } else {
      dispatch(changeScreen(USER_FLOW_PREV, currentScreen, screens, timeline));
    }
    //timeline UPDATE, cure, processing
  };

  const onClick = () => (goBack ? goBack() : handleGoBack());

  const renderComponent = () => {
    if (comp && React.isValidElement(comp)) {
      return React.cloneElement(comp as React.ReactElement<any>, { onClick });
    }

    if (newBackButton) {
      return (
        <img
          src={BACK_ARROW_SVG_ICON}
          alt="back-icon"
          onClick={onClick}
          style={{
            marginRight: '15px',
            marginBottom: '2px',
            cursor: 'pointer'
          }}
        />
      );
    } else if (newOnboardingScreen) {
      return (
        <img
          src={BACK_BUTTON_ONBOARDING_ICON}
          alt="back"
          width="39px"
          height="39px"
          style={{
            cursor: 'pointer'
          }}
          onClick={onClick}
        />
      );
    } else {
      return (
        <img
          src={BACK_ARROW_ICON}
          alt="back-arrow"
          className={joinClassNames('back-arrow', className)}
          onClick={onClick}
        />
      );
    }
  };

  return <>{(isModal || !isFirstScreen) && renderComponent()}</>;
};

export default BackButton;
